(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 96325:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(1040);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/web-view/index.js
var web_view = __webpack_require__(28686);
var web_view_default = /*#__PURE__*/__webpack_require__.n(web_view);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  min-height: 100dvh; // fallback (above) if browser does not support dvh units\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var FullHeightRow = (0,styled_components_browser_esm["default"])(ahm_ui/* Row */.X2).withConfig({
    componentId: "sc-5c98abc2-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/utils/add-decision/index.ts

var addDecision = function(currentDecisions, depth, newDecision) {
    var decisions = currentDecisions.slice(0, depth);
    if ((0,fp.isEmpty)(newDecision)) {
        return decisions;
    }
    return decisions.concat(newDecision);
};
/* harmony default export */ var add_decision = (addDecision);

// EXTERNAL MODULE: ./src/client/pages/contact-us/components/branch/index.tsx
var components_branch = __webpack_require__(34427);
// EXTERNAL MODULE: ./src/client/utils/browser.ts
var browser = __webpack_require__(40055);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/client/models/url/constants.ts
var constants = __webpack_require__(772);
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/options/current-member/images/change-cover.svg
/* harmony default export */ var change_cover = ({"src":"/_next/static/media/change-cover.db6fc541.svg","height":280,"width":279});
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/options/current-member/images/health-insurance.svg
/* harmony default export */ var health_insurance = ({"src":"/_next/static/media/health-insurance.4e27584f.svg","height":209,"width":346});
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/options/current-member/images/hospital.svg
/* harmony default export */ var hospital = ({"src":"/_next/static/media/hospital.bee2e482.svg","height":199,"width":198});
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/options/current-member/data.ts




var extrasOptionData = {
    queryType: {
        image: {
            src: health_insurance.src
        },
        links: [
            {
                name: "Make an extras claim",
                url: "".concat(constants.URLS.MEMBERS.CLAIMS)
            },
            {
                name: "Check your limits or waiting periods",
                url: "".concat(constants.URLS.MEMBERS.YOUR_COVER)
            },
            {
                name: "Find a provider",
                url: "".concat(constants.URLS.MEMBERS.FIND_A_PROVIDER)
            }, 
        ],
        title: "Extras"
    },
    relatedQuestions: {
        links: [
            {
                name: "What can I get back on my extras claim?",
                url: "".concat(constants.URLS.HELP.HOW_MUCH_WILL_I_GET_BACK_ON_MY_EXTRAS_CLAIM)
            },
            {
                name: "How do I make an extras claim online?",
                url: "".concat(constants.URLS.HELP.MAKE_AN_EXTRA_CLAIM)
            },
            {
                name: "Dental cover explained",
                url: "".concat(constants.URLS.SALES.EXPLAINED_DENTAL_AND_ORTHODONTICS)
            },
            {
                name: "How does extras cover work?",
                url: "".concat(constants.URLS.HELP.HOW_DOES_EXTRA_COVER_WORK)
            }, 
        ]
    }
};
var hospitalOptionData = {
    queryType: {
        image: {
            src: hospital.src
        },
        links: [
            {
                name: "My cover overview",
                url: "".concat(constants.URLS.MEMBERS.YOUR_COVER)
            },
            {
                name: "Hospital cover check",
                url: "".concat(constants.URLS.MEMBERS.HOSPITAL_COVER_CHECK)
            },
            {
                name: "Hospital and ambulance claims",
                url: "".concat(constants.URLS.MEMBERS.CLAIMS_HOSPITAL_AMBULANCE)
            }, 
        ],
        scrollTo: "Hospital",
        title: "Hospital"
    },
    relatedQuestions: {
        links: [
            {
                name: "Going to hospital guide",
                url: "".concat(constants.URLS.HELP.GOING_TO_HOSPITAL_GUIDE)
            },
            {
                name: "Getting the most out of hospital cover",
                url: "".concat(constants.URLS.SALES.EXPLAINED_GETTING_THE_MOST_OUT_OF_PRIVATE_HOSPITAL_COVER)
            },
            {
                name: "What’s a partner hospital or day surgery?",
                url: "".concat(constants.URLS.HELP.PARTNER_HOSPITAL)
            },
            {
                name: "How do I make an ambulance claim?",
                url: "".concat(constants.URLS.HELP.HOW_DO_I_MAKE_AN_AMBULANCE_CLAIM)
            }, 
        ]
    }
};
var myAccountOptionData = {
    queryType: {
        image: {
            src: health_insurance.src
        },
        links: [
            {
                name: "Manage payments",
                url: "".concat(constants.URLS.MEMBERS.PAYMENTS)
            },
            {
                name: "Update my personal details",
                url: "".concat(constants.URLS.MEMBERS.SETTINGS)
            },
            {
                name: "Update income tier",
                url: "".concat(constants.URLS.MEMBERS.UPDATE_AGR)
            }, 
        ],
        title: "My account"
    },
    relatedQuestions: {
        links: [
            {
                name: "How can I pay my premiums?",
                url: "".concat(constants.URLS.HELP.HOW_CAN_I_PAY_MY_PREMIUMS)
            },
            {
                name: "How do I set up or change direct debit?",
                url: "".concat(constants.URLS.HELP.DIRECT_DEBIT_DETAILS_SETUP_OR_UPDATE)
            },
            {
                name: "How do I change my payment frequency or date?",
                url: "".concat(constants.URLS.HELP.HOW_DO_I_CHANGE_MY_PAYMENT_FREQUENCY)
            },
            {
                name: "How do I update my contact details?",
                url: "".concat(constants.URLS.HELP.HOW_DO_I_UPDATE_MY_CONTACT_DETAILS)
            }, 
        ]
    }
};
var changeCoverOptionData = {
    queryType: {
        image: {
            src: change_cover.src
        },
        links: [
            {
                name: "Change cover online",
                url: "".concat(constants.URLS.MEMBERS.CHANGE_YOUR_COVER)
            },
            {
                name: "My cover overview",
                url: "".concat(constants.URLS.MEMBERS.YOUR_COVER)
            },
            {
                name: "Check what I’m covered for",
                url: "".concat(constants.URLS.MEMBERS.DOCUMENTS, "?type=product-guides")
            }, 
        ],
        title: "Change cover"
    },
    relatedQuestions: {
        links: [
            {
                name: "How do I change my cover?",
                url: "".concat(constants.URLS.HELP.HOW_DO_I_CHANGE_MY_COVER)
            },
            {
                name: "Why switch cover?",
                url: "".concat(constants.URLS.SALES.EXPLAINED_SWITCHING)
            },
            {
                name: "Adding or removing people",
                url: "".concat(constants.URLS.HELP.ADDING_OR_REMOVING_PEOPLE)
            },
            {
                name: "What’s my excess?",
                url: "".concat(constants.URLS.HELP.WHAT_IS_EXCESS)
            }, 
        ]
    }
};
var somethingElseOptionData = {
    queryType: {
        image: {
            src: health_insurance.src
        },
        links: [
            {
                name: "Request a new card",
                url: "".concat(constants.URLS.MEMBERS.REPLACEMENT_CARD)
            },
            {
                name: "Check my product guide",
                url: "".concat(constants.URLS.MEMBERS.DOCUMENTS, "?type=product-guides")
            },
            {
                name: "Submit a form or document",
                url: "".concat(constants.URLS.MEMBERS.DOCUMENTS)
            }, 
        ],
        title: "Something else"
    },
    relatedQuestions: {
        links: [
            {
                name: "Tax FAQ’s",
                url: "".concat(constants.URLS.HELP.TAX_FAQS)
            },
            {
                name: "How do I make an ambulance claim?",
                url: "".concat(constants.URLS.HELP.HOW_DO_I_MAKE_AN_AMBULANCE_CLAIM)
            },
            {
                name: "Use digital card for Android",
                url: "".concat(constants.URLS.HELP.DIGITAL_CARD_ANDROID)
            },
            {
                name: "Using digital card for iPhone",
                url: "".concat(constants.URLS.SALES.EXPLAINED_APPLE_CARD)
            }, 
        ]
    }
};

// EXTERNAL MODULE: ./src/client/models/table-of-contents/constants/index.ts
var table_of_contents_constants = __webpack_require__(3971);
// EXTERNAL MODULE: ./src/client/pages/contact-us/components/contact-options/index.tsx + 7 modules
var contact_options = __webpack_require__(53753);
// EXTERNAL MODULE: ./src/client/pages/contact-us/components/decision-tree/options/utils/format-contact-options/index.tsx
var format_contact_options = __webpack_require__(56515);
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/query-type/index.tsx

function query_type_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    query_type_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4rem 0.75rem;\n\n  @media (min-width: ",
        ") {\n    padding: 5.5rem 1rem;\n  }\n\n  @media (min-width: ",
        ") {\n    padding: 7.5rem 1rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media (min-width: ",
        ") {\n    display: block;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  order: 1;\n  padding: 2.5rem;\n\n  @media (min-width: ",
        ") {\n    order: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 1.25rem 0;\n  border-bottom: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    transform: scaleX(0.99);\n    transition: transform 0.1s ease-in-out;\n    transform-origin: left;\n\n    &:hover {\n      transform: scaleX(1);\n      border-bottom: 2px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var SubHeading = (0,styled_components_browser_esm["default"])(ahm_ui.H2).withConfig({
    componentId: "sc-2f9d2b89-0"
})(query_type_templateObject(), components_branch/* focusVisible */.bP);
var StyledSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-2f9d2b89-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
}, function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var BreakTagHiddenMobile = styled_components_browser_esm["default"].br.withConfig({
    componentId: "sc-2f9d2b89-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
});
var ImageColumn = (0,styled_components_browser_esm["default"])(ahm_ui/* Col */.JX).withConfig({
    componentId: "sc-2f9d2b89-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var Link = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-2f9d2b89-4"
})(_templateObject4(), function(param) {
    var colors = param.theme.colors;
    return colors.grey20;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(param) {
    var colors = param.theme.colors;
    return colors.grey70;
});
var subHeadingLine1 = "Manage your cover online when it suits you.";
var subHeadingLine2 = "Don’t have an account?";
var linkText = "Register";
var QueryType = function(param) {
    var links = param.links, image = param.image, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        variant: "regular",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
                variant: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading, {
                        variant: "marginBottomSpacer9",
                        id: title,
                        tabIndex: "0",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.H3, {
                        looksLike: "h5",
                        variant: [
                            "regular",
                            "marginBottomSpacer10"
                        ],
                        children: [
                            subHeadingLine1,
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakTagHiddenMobile, {}),
                            subHeadingLine2,
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                "aria-label": "".concat(subHeadingLine1, " ").concat(subHeadingLine2, " ").concat(linkText),
                                to: constants.URLS.MEMBERS.REGISTRATION,
                                children: linkText
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Row */.X2, {
                    variant: "marginTopSpacer7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageColumn, {
                            df: 6,
                            sm: 12,
                            variant: [
                                "paddingTopSpacer7",
                                "paddingBottomSpacer7"
                            ],
                            children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                src: image.src
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                            df: 6,
                            sm: 12,
                            children: (0,fp.map)(function(param) {
                                var _inNewTab = param.inNewTab, inNewTab = _inNewTab === void 0 ? true : _inNewTab, name = param.name, url = param.url;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                                    variant: "marginBottomSpacer10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                        icon: {
                                            name: "arrow-right-long",
                                            position: "right"
                                        },
                                        inNewTab: inNewTab,
                                        isUnstyled: true,
                                        to: url,
                                        variant: "wideSpaceBetween",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                            looksLike: "h5",
                                            children: name
                                        })
                                    })
                                }, name);
                            }, links)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var query_type = (QueryType);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/related-questions/index.tsx

function related_questions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  padding: 4rem 0 3rem;\n\n  @media (min-width: ",
        ") {\n    padding: 5.5rem 0 3rem;\n  }\n\n  @media (min-width: ",
        ") {\n    padding: 7.5rem 0.25rem 6.5rem;\n  }\n"
    ]);
    related_questions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function related_questions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1rem 0;\n  margin: auto;\n  max-width: 70rem;\n  justify-content: center;\n\n  @media (min-width: ",
        ") {\n    padding: 2.25rem 0;\n  }\n"
    ]);
    related_questions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function related_questions_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.5rem;\n\n  @media (min-width: ",
        ") {\n    padding: 0.75rem;\n  }\n"
    ]);
    related_questions_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function related_questions_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: left;\n  padding: 1.5rem;\n  height: 100%;\n  max-width: 100%;\n\n  @media (min-width: ",
        ") {\n    padding: 2rem;\n\n    &:hover {\n      padding: calc(2rem - 1px);\n    }\n  }\n"
    ]);
    related_questions_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function related_questions_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1rem;\n  height: 3.5rem;\n  padding: 1.125rem;\n\n  @media (min-width: ",
        ") {\n    margin-top: 1.25rem;\n  }\n"
    ]);
    related_questions_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: 16px;\n\n  @media (min-width: ",
        ") {\n    font-size: 20px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var RelatedQuestionsSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-26547cff-0"
})(related_questions_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
}, function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var LinkRow = (0,styled_components_browser_esm["default"])(ahm_ui/* Row */.X2).withConfig({
    componentId: "sc-26547cff-1"
})(related_questions_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
});
var LinkCol = (0,styled_components_browser_esm["default"])(ahm_ui/* Col */.JX).withConfig({
    componentId: "sc-26547cff-2"
})(related_questions_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var LinkButton = (0,styled_components_browser_esm["default"])(ahm_ui/* JourneyButton */.TJ).withConfig({
    componentId: "sc-26547cff-3"
})(related_questions_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
});
var HelpButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-26547cff-4"
})(related_questions_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
});
var Question = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-26547cff-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
});
var RelatedQuestions = function(param) {
    var cta = param.cta, links = param.links, subHeading = param.subHeading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RelatedQuestionsSection, {
        variant: [
            "regular",
            "marginBottomSpacer10"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                variant: "marginBottomSpacer9",
                children: "Related questions"
            }),
            subHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                looksLike: "h5",
                variant: [
                    "regular",
                    "marginBottomSpacer10"
                ],
                children: subHeading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkRow, {
                children: [
                    (0,fp.map)(function(param) {
                        var disabled = param.disabled, inNewTab = param.inNewTab, name = param.name, url = param.url;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkCol, {
                            df: 6,
                            sm: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton, {
                                to: url,
                                disabled: disabled,
                                inNewTab: inNewTab,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Question, {
                                    looksLike: "h5",
                                    "data-testid": "question",
                                    children: name
                                })
                            })
                        }, name);
                    }, links),
                    cta && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkCol, {
                        df: 3,
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpButton, {
                            variant: [
                                "wide",
                                "black"
                            ],
                            to: cta.to,
                            role: "button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                looksLike: "h6",
                                children: cta.title
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var related_questions = (RelatedQuestions);

// EXTERNAL MODULE: ./src/client/components/offers/logic/use-get-all-placeholders/index.ts
var use_get_all_placeholders = __webpack_require__(38153);
// EXTERNAL MODULE: ./src/client/cms/utils/use-table-of-contents/index.ts
var use_table_of_contents = __webpack_require__(30329);
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/options/current-member/index.tsx













var mapIDToOptionData = {
    changeCover: changeCoverOptionData,
    extrasAndClaiming: extrasOptionData,
    hospital: hospitalOptionData,
    myAccount: myAccountOptionData,
    somethingElse: somethingElseOptionData
};
var CurrentMember = function(param) {
    var id = param.id;
    var data = mapIDToOptionData[id];
    var ref = (0,use_table_of_contents/* default */.Z)({
        fragment: table_of_contents_constants/* FRAGMENTS.CONTACTS */.Y.CONTACTS,
        skip: false,
        slug: table_of_contents_constants/* SLUG.CURRENT_MEMBER_CONTACTS */.T.CURRENT_MEMBER_CONTACTS
    }), items = ref.items, isLoadingTOC = ref.loading;
    var ref1 = (0,use_get_all_placeholders/* default */.Z)(), isLoadingPlaceholders = ref1.loading, placeholders = ref1.placeholders;
    var isOptionsLoaded = !isLoadingPlaceholders && !isLoadingTOC;
    var contactOptions = (0,format_contact_options/* default */.Z)({
        customOptions: [
            {
                contactOptionId: contact_options/* optionConstantIds.memberLogIn */.e.memberLogIn
            }, 
        ],
        id: format_contact_options/* CONTACT_OPTION_ID.CURRENT_MEMBER */.X.CURRENT_MEMBER,
        items: items,
        placeholders: placeholders,
        title: "Didn’t find what you’re after?"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: components_branch/* firstRowId */.M7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                    isBoxed: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(query_type, (0,_object_spread/* default */.Z)({}, data.queryType))
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                isBoxed: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(related_questions, (0,_object_spread/* default */.Z)({}, data.relatedQuestions))
                })
            }),
            isOptionsLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                isBoxed: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_options/* default */.Z, (0,_object_spread/* default */.Z)({}, contactOptions))
                })
            })
        ]
    });
};
/* harmony default export */ var current_member = (CurrentMember);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/data.ts
var decisionTree = {
    branches: [
        {
            branches: [
                {
                    content: {
                        scrollTo: "Get in touch about joining",
                        title: "Looking to join"
                    },
                    id: "lookingToJoin"
                },
                {
                    branches: [
                        {
                            content: {
                                scrollTo: "Extras",
                                title: "Extras and claiming"
                            },
                            id: "extrasAndClaiming"
                        },
                        {
                            content: {
                                scrollTo: "Hospital",
                                title: "Hospital"
                            },
                            id: "hospital"
                        },
                        {
                            content: {
                                scrollTo: "My account",
                                title: "My account"
                            },
                            id: "myAccount"
                        },
                        {
                            content: {
                                scrollTo: "Change cover",
                                title: "Change cover"
                            },
                            id: "changeCover"
                        },
                        {
                            content: {
                                scrollTo: "Something else",
                                title: "Something else"
                            },
                            id: "somethingElse"
                        }, 
                    ],
                    content: {
                        branchHeading: "My query is about …",
                        scrollTo: "My query is about …",
                        title: "Current member"
                    },
                    id: "currentMember"
                }, 
            ],
            content: {
                branchHeading: "About me …",
                scrollTo: "About me …",
                title: "Health insurance"
            },
            id: "healthInsurance"
        },
        {
            content: {
                scrollTo: "Get in touch",
                title: "Other insurance"
            },
            id: "otherInsurance"
        }, 
    ],
    content: {
        branchHeading: "What can we help with?",
        title: "Decision Tree"
    },
    id: "root"
};
/* harmony default export */ var data = (decisionTree);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/utils/get-branch/index.ts

var getBranch = function(initialTree) {
    if ((0,fp.isEmpty)(initialTree)) {
        return function() {
            return null;
        };
    }
    return function(decisions, depth) {
        if (depth > decisions.length) {
            return null;
        }
        var branch = initialTree;
        // eslint-disable-next-line lodash-fp/no-unused-result
        (0,fp.map)(function(current) {
            var decision = decisions[current];
            var ref;
            branch = (ref = (0,fp.find)({
                id: decision
            }, branch === null || branch === void 0 ? void 0 : branch.branches)) !== null && ref !== void 0 ? ref : null;
        }, (0,fp.range)(0, depth));
        return branch;
    };
};
/* harmony default export */ var get_branch = (getBranch);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/why-ahm/index.tsx

function why_ahm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin: 4rem 0;\n\n  @media (min-width: ",
        ") {\n    margin: 4rem;\n  }\n"
    ]);
    why_ahm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function why_ahm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-bottom: 2rem;\n\n  @media (min-width: ",
        ") {\n    margin-bottom: 4rem;\n  }\n"
    ]);
    why_ahm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function why_ahm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    padding: 1rem 4rem;\n  }\n"
    ]);
    why_ahm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d13f9b73-0"
})(why_ahm_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var Title = (0,styled_components_browser_esm["default"])(ahm_ui.H2).withConfig({
    componentId: "sc-d13f9b73-1"
})(why_ahm_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-d13f9b73-2"
})(why_ahm_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
});
var WhyAhm = function(param) {
    var link = param.link, linkText = param.linkText, textBlocks = param.textBlocks, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
        padding: "1rem",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* AxisSwitcher */.e$, {
                    limit: 3,
                    threshold: "60rem",
                    space: "2.5rem",
                    children: (0,fp.map)(function(param) {
                        var description = param.description, heading = param.heading;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H4, {
                                    variant: [
                                        "center",
                                        "marginTopSpacer10",
                                        "simpleBit"
                                    ],
                                    children: heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    variant: [
                                        "center",
                                        "marginTopSpacer11",
                                        "regular"
                                    ],
                                    children: description
                                })
                            ]
                        }, heading);
                    }, textBlocks)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                    variant: [
                        "border",
                        "marginTopSpacer5",
                        "white"
                    ],
                    to: link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                        looksLike: "h6",
                        children: linkText
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var why_ahm = (WhyAhm);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/why-ahm/data.ts
var whyAhmData = [
    {
        description: "We take a fresh approach to health insurance and cut out the complexity. Everything we do is about making things simpler, so you can make the most of what matters to you.",
        heading: "Straightforward"
    },
    {
        description: "Just let us know within 30 days of joining and as long as you haven’t made any claims we’ll refund your premiums. Simple.",
        heading: "30 day cooling off period"
    },
    {
        description: "It takes less than 3 minutes to join ahm, but who’s counting? Just have your Medicare card and payment details ready to go.",
        heading: "Join online"
    }, 
];
/* harmony default export */ var why_ahm_data = (whyAhmData);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/options/looking-to-join/index.tsx














var relatedQuestions = {
    cta: {
        title: "More help topics",
        to: constants.URLS.HELP.HOME
    },
    links: [
        {
            inNewTab: true,
            name: "Private health insurance 101",
            url: "".concat(constants.URLS.HELP.PRIVATE_HEALTH_INSURANCE_101)
        },
        {
            inNewTab: true,
            name: "What does joining direct mean?",
            url: "".concat(constants.URLS.SALES.EXPLAINED_JOIN_DIRECT)
        },
        {
            inNewTab: true,
            name: "What is hospital cover?",
            url: "".concat(constants.URLS.SALES.EXPLAINED_WHAT_IS_PRIVATE_HOSPITAL_COVER)
        },
        {
            inNewTab: true,
            name: "What is extras cover?",
            url: "".concat(constants.URLS.SALES.EXPLAINED_WHAT_IS_EXTRAS_COVER)
        }, 
    ],
    subHeading: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "We may have answered your question in our handy ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                to: constants.URLS.HELP.HOME,
                children: "help section."
            })
        ]
    })
};
var LookingToJoin = function() {
    var ref = (0,use_table_of_contents/* default */.Z)({
        fragment: table_of_contents_constants/* FRAGMENTS.CONTACTS */.Y.CONTACTS,
        skip: false,
        slug: table_of_contents_constants/* SLUG.LOOKING_TO_JOIN_CONTACTS */.T.LOOKING_TO_JOIN_CONTACTS
    }), items = ref.items, isLoadingTOC = ref.loading;
    var ref1 = (0,use_get_all_placeholders/* default */.Z)(), isLoadingPlaceholders = ref1.loading, placeholders = ref1.placeholders;
    if (isLoadingPlaceholders || isLoadingTOC) {
        return null;
    }
    var contactOptions = (0,format_contact_options/* default */.Z)({
        appendCustomOptions: true,
        customOptions: [
            {
                contactOptionId: contact_options/* optionConstantIds.getACallBack */.e.getACallBack
            }, 
        ],
        id: format_contact_options/* CONTACT_OPTION_ID.LOOKING_TO_JOIN */.X.LOOKING_TO_JOIN,
        items: items,
        placeholders: placeholders,
        title: "Get in touch about joining"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: components_branch/* firstRowId */.M7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                    isBoxed: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_options/* default */.Z, (0,_object_spread/* default */.Z)({}, contactOptions))
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                isBoxed: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(related_questions, (0,_object_spread/* default */.Z)({}, relatedQuestions))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                isBoxed: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(why_ahm, {
                        link: constants.URLS.SALES.FIND_HEALTH_INSURANCE,
                        linkText: "Find cover",
                        textBlocks: why_ahm_data,
                        title: "Why ahm"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var looking_to_join = (LookingToJoin);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/other-insurance-contacts/data.tsx

var otherInsuranceContactLinks = function() {
    return [
        {
            link: {
                name: "Contact Us",
                url: "".concat(constants.URLS.SALES.LIFE_INSURANCE, "/help")
            },
            title: "Life Insurance"
        },
        {
            link: {
                name: "Contact Us",
                url: constants.URLS.SALES.LIFE_INSURANCE_CONTACT_US
            },
            title: "Income protection"
        },
        {
            link: {
                name: "Contact Us",
                url: constants.URLS.SALES.TRAVEL_INSURANCE_CONTACT_US
            },
            title: "Travel Insurance"
        },
        {
            link: {
                name: "Contact Us",
                url: constants.URLS.SALES.CAR_INSURANCE_CONTACT_US
            },
            title: "Car Insurance"
        },
        {
            link: {
                name: "Contact Us",
                url: constants.URLS.SALES.HOME_INSURANCE_CONTACT_US
            },
            title: "Home Insurance"
        }, 
    ];
};
/* harmony default export */ var other_insurance_contacts_data = (otherInsuranceContactLinks);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/other-insurance-contacts/index.tsx

function other_insurance_contacts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n"
    ]);
    other_insurance_contacts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function other_insurance_contacts_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: fit-content;\n"
    ]);
    other_insurance_contacts_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function other_insurance_contacts_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2.5rem;\n\n  @media (min-width: ",
        ") {\n    margin-bottom: 4.5rem;\n  }\n\n  ",
        "\n"
    ]);
    other_insurance_contacts_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ContactRow = (0,styled_components_browser_esm["default"])(ahm_ui/* Row */.X2).withConfig({
    componentId: "sc-ea9547c3-0"
})(other_insurance_contacts_templateObject());
var ContactCol = (0,styled_components_browser_esm["default"])(ahm_ui/* Col */.JX).withConfig({
    componentId: "sc-ea9547c3-1"
})(other_insurance_contacts_templateObject1());
var Heading = (0,styled_components_browser_esm["default"])(ahm_ui.H2).withConfig({
    componentId: "sc-ea9547c3-2"
})(other_insurance_contacts_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
}, components_branch/* focusVisible */.bP);
var OtherInsuranceContacts = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Section */.$0, {
        variant: [
            "regular",
            "marginTopSpacer6",
            "marginBottomSpacer6"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactRow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                    id: "Get in touch",
                    tabIndex: "0",
                    children: "Get in touch"
                })
            }),
            (0,fp.map)(function(param) {
                var title = param.title, link = param.link, description = param.description, subtitle = param.subtitle;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactRow, {
                    variant: "marginBottomSpacer9",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactCol, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                variant: [
                                    "bold",
                                    "marginBottomSpacer12"
                                ],
                                children: title
                            }),
                            subtitle,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                variant: description ? "marginBottomSpacer12" : "",
                                to: link.url,
                                children: link.name
                            }),
                            description
                        ]
                    })
                }, title);
            }, other_insurance_contacts_data()),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactRow, {
                variant: "marginTopSpacer7",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactCol, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                            variant: [
                                "bold",
                                "marginBottomSpacer12"
                            ],
                            children: "Feedback and complaints"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                            to: "https://help.ahm.com.au/hc/en-us/articles/115005292887",
                            children: "Find out more"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var other_insurance_contacts = (OtherInsuranceContacts);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/options/other-insurance/index.tsx







var other_insurance_relatedQuestions = {
    links: [
        {
            name: "Life insurance",
            url: constants.URLS.SALES.LIFE_INSURANCE
        },
        {
            name: "Travel insurance",
            url: constants.URLS.SALES.TRAVEL_INSURANCE
        },
        {
            name: "Car insurance",
            url: constants.URLS.SALES.CAR_INSURANCE
        },
        {
            name: "Home and contents insurance",
            url: constants.URLS.SALES.HOME_INSURANCE
        },
        {
            name: "Income protection insurance",
            url: constants.URLS.SALES.INCOME_INSURANCE
        }, 
    ]
};
var OtherInsurance = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                isBoxed: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(other_insurance_contacts, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                isBoxed: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(related_questions, (0,_object_spread/* default */.Z)({}, other_insurance_relatedQuestions))
                })
            })
        ]
    });
};
/* harmony default export */ var other_insurance = (OtherInsurance);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/decision-tree/index.tsx
















var getDecisionBranch = get_branch(data);
var getBranchComponentHandler = {
    changeCover: /*#__PURE__*/ (0,jsx_runtime.jsx)(current_member, {
        id: "changeCover"
    }),
    currentMember: null,
    extrasAndClaiming: /*#__PURE__*/ (0,jsx_runtime.jsx)(current_member, {
        id: "extrasAndClaiming"
    }),
    healthInsurance: null,
    hospital: /*#__PURE__*/ (0,jsx_runtime.jsx)(current_member, {
        id: "hospital"
    }),
    lookingToJoin: /*#__PURE__*/ (0,jsx_runtime.jsx)(looking_to_join, {}),
    myAccount: /*#__PURE__*/ (0,jsx_runtime.jsx)(current_member, {
        id: "myAccount"
    }),
    otherInsurance: /*#__PURE__*/ (0,jsx_runtime.jsx)(other_insurance, {}),
    root: null,
    somethingElse: /*#__PURE__*/ (0,jsx_runtime.jsx)(current_member, {
        id: "somethingElse"
    })
};
var DecisionTree = function() {
    var query = (0,router.useRouter)().query;
    var mfa = query.mfa;
    var ref = (0,react.useState)([]), decisions = ref[0], setDecisions = ref[1];
    var isMfaRedirect = !(0,fp.isUndefined)(mfa);
    var scrollToElement = function(id) {
        var element = document.getElementById(id);
        var scrollTopOffset = 100;
        if (element) {
            element.focus({
                preventScroll: true
            });
            window.scroll({
                behavior: "smooth",
                top: element.getBoundingClientRect().top + window.scrollY - scrollTopOffset
            });
        }
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    var onSelectHandler = function(depth) {
        return function(selected, content) {
            setDecisions(function(prevState) {
                return add_decision(prevState, depth, selected);
            });
            setTimeout(function() {
                if (content === null || content === void 0 ? void 0 : content.scrollTo) {
                    scrollToElement(content === null || content === void 0 ? void 0 : content.scrollTo);
                }
            }, 250);
        };
    };
    // For redirection from the MFA forms - This will force the decision tree to complete and then scroll to the contact section
    // There was feedback that members were getting lost with the decision tree and not knowing how to get to the contact section
    // We do this here instead of the initial state setup above because the SSR is causing the decision tree to not render correctly
    // and ignores the prefilled state
    (0,react.useEffect)(function() {
        if (!isMfaRedirect) {
            return;
        }
        setDecisions([
            "healthInsurance",
            "currentMember",
            "myAccount"
        ]);
        setTimeout(function() {
            scrollToElement("current member");
        }, 350);
    }, [
        isMfaRedirect
    ]);
    var selectedDecision = decisions[decisions.length - 1];
    var doc = browser/* default.getDocument */.Z.getDocument();
    var ref1;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'cookie' does not exist on type '{ __productReviewCallbackQueue: { push: LodashNoop; }; __productReviewSettings: {}; activeElement: null; addEventListener: LodashNoop; body: { appendChild: LodashNoop; removeChild: LodashNoop; style: { ...; }; }; ... 8 more ...; supports: LodashNoop; } | Document'.
    var isWebView = web_view_default().isWebView(cookie.parse((ref1 = doc === null || doc === void 0 ? void 0 : doc.cookie) !== null && ref1 !== void 0 ? ref1 : ""));
    var WrapperComponent = isWebView ? FullHeightRow : ahm_ui/* Row */.X2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperComponent, {
                isBoxed: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Col */.JX, {
                    df: true,
                    variant: "paddingBottomSpacer2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                            variant: [
                                "center",
                                "marginTopSpacer5",
                                "marginBottomSpacer11"
                            ],
                            children: "Contact us"
                        }),
                        (0,fp.map)(function(index) {
                            var branch = getDecisionBranch(decisions, index);
                            var selectedBranch = (0,fp.find)({
                                id: decisions[index]
                            }, branch === null || branch === void 0 ? void 0 : branch.branches);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_branch/* default */.ZP, {
                                // @ts-expect-error - Automatic, Please fix when editing this file
                                branches: branch.branches,
                                // @ts-expect-error - Automatic, Please fix when editing this file
                                branchHeading: branch.content.branchHeading,
                                selected: selectedBranch,
                                onSelect: onSelectHandler(index)
                            }, branch.content.title);
                        }, (0,fp.range)(0, decisions.length + 1))
                    ]
                })
            }),
            selectedDecision && getBranchComponentHandler[selectedDecision]
        ]
    });
};
/* harmony default export */ var decision_tree = (DecisionTree);

// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
// EXTERNAL MODULE: ./src/client/components/request-a-call/drawer/index.tsx
var drawer = __webpack_require__(68442);
;// CONCATENATED MODULE: ./src/client/pages/contact-us/utils/useContacts/index.ts



/**
 * This hook essentially kicks off the contacts related sanity calls to ensure the
 * Apollo cache is populated before the customer gets to the point in the decision tree
 * where contact details need to be shown.
 */ var useContacts = function() {
    (0,use_get_all_placeholders/* default */.Z)();
    (0,use_table_of_contents/* default */.Z)({
        fragment: table_of_contents_constants/* FRAGMENTS.CONTACTS */.Y.CONTACTS,
        skip: false,
        slug: table_of_contents_constants/* SLUG.LOOKING_TO_JOIN_CONTACTS */.T.LOOKING_TO_JOIN_CONTACTS
    });
    (0,use_table_of_contents/* default */.Z)({
        fragment: table_of_contents_constants/* FRAGMENTS.CONTACTS */.Y.CONTACTS,
        skip: false,
        slug: table_of_contents_constants/* SLUG.CURRENT_MEMBER_CONTACTS */.T.CURRENT_MEMBER_CONTACTS
    });
};
/* harmony default export */ var utils_useContacts = (useContacts);

;// CONCATENATED MODULE: ./src/client/pages/contact-us/index.tsx








var ContactUsPage = function() {
    utils_useContacts();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
                titleTemplate: ui.SHORT_PAGE_TITLE_TEMPLATE,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Contact ahm | Contact number & details"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Got questions about health insurance? Chat with us online, via the ahm app, or give us a call. Read on for other insurance queries."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
                size: "extraExtraLarge",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(decision_tree, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(drawer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var contact_us = (ContactUsPage);

;// CONCATENATED MODULE: ./pages/contact-us/index.page.ts

/* harmony default export */ var index_page = (contact_us);


/***/ }),

/***/ 38153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GET_PLACEHOLDERS_QUERY */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71439);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46829);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query AllPlaceholder {\n    allPlaceholder {\n      _id\n      name\n      identifier {\n        current\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var GET_PLACEHOLDERS_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__.gql)(_templateObject());
var useGetAllPlaceholders = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _skip = ref.skip, skip = _skip === void 0 ? false : _skip;
    var ref1 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__.useQuery)(GET_PLACEHOLDERS_QUERY, {
        skip: skip
    }), data = ref1.data, loading = ref1.loading;
    return {
        loading: loading,
        placeholders: data === null || data === void 0 ? void 0 : data.allPlaceholder
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetAllPlaceholders);


/***/ }),

/***/ 84466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var getOrNull = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null);
// @ts-expect-error - Automatic, Please fix when editing this file
var selectCurrentDrawer = getOrNull("drawer.openDrawerId");
/* harmony default export */ __webpack_exports__["Z"] = (selectCurrentDrawer);


/***/ }),

/***/ 85500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X5": function() { return /* binding */ scrollTo; },
/* harmony export */   "kI": function() { return /* binding */ scrollToElement; },
/* harmony export */   "wA": function() { return /* binding */ getScrollPosition; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_is_server__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41105);


// Due to Firefox / Chrome following different standards. https://miketaylr.com/posts/2014/11/document-body-scrollTop.html
function getScrollPosition() {
    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
}
function scrollTo() {
    var to = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var isServer = (0,_get_is_server__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    if (isServer) {
        return;
    }
    window.scrollTo({
        behavior: "smooth",
        top: to
    });
    // this is used for `back to top` button after being clicked, return tab order to where it has id `backToTopPoint`
    var backToTopPoint = document.getElementById("backToTopPoint");
    if (backToTopPoint) {
        backToTopPoint.focus({
            preventScroll: true
        });
    }
}
function scrollToElement(element) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNull)(element)) {
        return;
    }
    var scrollPosition = element.getBoundingClientRect().top + getScrollPosition() + offset;
    scrollTo(scrollPosition);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9664,9774,2888,179], function() { return __webpack_exec__(96325); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);